import React, { useState, useEffect } from "react";
import { Column, MasterDetail, GroupItem, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../Componentes/Basicos/LVGridCabecera";
import { PaginaListado } from "../../Componentes/Compuestos/Paginas/PaginaListado";
import PRO_Fabricacion_Detalle from "./PRO_Fabricacion_Detalle";
import LVButtonNuevo from "../../Componentes/Basicos/LVButtonNuevo";
import { ObtieneParametros, TratamientoDeVariableBoolean } from "neftis7_apicaller/src/funciones/Varios";
import { function_PRO_Fabricacion_Cabecera_ReporteFabricacion, function_PRO_Fabricacion_Cabecera_ReporteFabricacion_EnvioMail } from "neftis7_apicaller/src/funciones/PRO/PRO_Fabricacion_Cabecera";

export const PRO_Fabricacion_ = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState([])
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState([])
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState([])
  const { PRO_Fabricacion_Cabecera: { function_PRO_Fabricacion_Cabecera_Listar } } = require('neftis7_apicaller');

  const handleDataLoaded = (data) => {
    setData(data);
  };

  const getDataParametros = async () => {// Llama a función asíncrona y maneja los datos
    try {
      const datosModificadores = await ObtieneParametros();
      const globalUsaArticulosConPresentacionLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion)
      const globalUsaArticulosConTamanoLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano)
      const globalUsaArticulosConUnidadDeMedidaLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida)

      setGlobalUsaArticulosConPresentacion(globalUsaArticulosConPresentacionLocal)
      setGlobalUsaArticulosConTamano(globalUsaArticulosConTamanoLocal)
      setGlobalUsaArticulosConUnidadDeMedida(globalUsaArticulosConUnidadDeMedidaLocal)

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
  };

  useEffect(() => {
    getDataParametros();
  }, []);

  const handleOnClickPrint = async (item) => {
    try {
      setLoading(true);
      const formato = "pdf"
      const reportData = await function_PRO_Fabricacion_Cabecera_ReporteFabricacion(item.IdFabricacion, formato);

      if (formato === 'pdf') {
        const file = new Blob([reportData], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = `Fabricacion${item.IdFabricacion}.pdf`; // Nombre del archivo con extensión
        link.click();
      } else if (formato === 'html') {
        const htmlContent = reportData.data;
        const newWindow = window.open();
        newWindow.document.write(htmlContent); // Mostrar HTML en nueva ventana
        newWindow.document.close();
      }

    } catch (error) {
      alert(error)
    } finally {
      setLoading(false);
    }
  };

  const handleOnClickEnviarEMail = async (item) => {
    try {
      setLoading(true);

      const correoElectronico = "";

      // Mostrar popup para confirmar o editar el correo
      const nuevoCorreo = window.prompt(
        "Se enviará el E-Mail a la siguiente dirección o ingrese una nueva:",
        correoElectronico
      );

      if (!nuevoCorreo) {
        alert("El envío ha sido cancelado.");
        return;
      }

      const formato = "pdf"
      const reportData = await function_PRO_Fabricacion_Cabecera_ReporteFabricacion_EnvioMail(item.IdFabricacion, nuevoCorreo);

      alert("Se ha enviado el E-Mail")
    } catch (error) {
      alert(error)
    } finally {
      setLoading(false);
    }
  };

  return (
    <PaginaListado
      Titulo="FABRICACIÓN"
      funcion={function_PRO_Fabricacion_Cabecera_Listar}
      onDataLoaded={handleDataLoaded}
    >
      {loading && (
        <div className="spinner-overlay">
          <div className="card-body text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
      )}
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          <LVButtonNuevo text="NUEVO (SIMPLIFICADA)" Url="/PRO_Fabricacion_ModificacionCreacion_Simplificada" />
          <LVButtonNuevo text="NUEVO ETAPAS (SIMPLIFICADA)" Url="/PRO_Fabricacion_ModificacionCreacion_SimplificadaEtapas" />
          <LVButtonNuevo text="LISTAS DE PRODUCCIÓN" Url="/PRO_Articulos_BOM" />
        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            PageSize={11}
            id="gridContainer"
            keyExpr="IdFabricacion"
            onClickPrint={handleOnClickPrint}
            onClickEnviarEmail={handleOnClickEnviarEMail}
          >
            <Summary>
              <TotalItem
                column="IdFabricacion"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />

              <GroupItem
                column="IdFabricacion"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`}
                showInGroupFooter={true} />
            </Summary>
            <Column caption="Código" dataField="IdFabricacion" width="120" alignment="Right" dataType="number" />
            <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
            <Column caption="Fecha" dataField="FechaSinHora" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} visible={false} />
            <Column caption="Tipo" dataField="TipoFabricacion" width="200" alignment="Left" dataType="string" />
            <Column caption="Número" dataField="NumeroFantasia" width="200" alignment="Left" dataType="string" />

            <Column caption="Artículo" alignment="Center">
              <Column caption="Código" dataField="CodigoArticuloFabricado" width="70" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="ArticuloFabricado" width="200" alignment="Left" dataType="string" />
            </Column>
            <Column caption="Presentación" alignment="Center" visible={globalUsaArticulosConPresentacion}>
              <Column caption="Código" dataField="CodigoPresentacionFabricado" width="70" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="PresentacionFabricado" width="200" alignment="Left" dataType="string" />
            </Column>
            <Column caption="Tamaño" alignment="Center" visible={globalUsaArticulosConTamano}>
              <Column caption="Código" dataField="CodigoTamanoFabricado" width="70" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="TamanoFabricado" width="200" alignment="Left" dataType="string" />
            </Column>
            <Column caption="Unidad de Medida" alignment="Center" visible={globalUsaArticulosConUnidadDeMedida}>
              <Column caption="Código" dataField="CodigoUnidadMedidaFabricado" width="70" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="UnidadMedidaFabricado" width="200" alignment="Left" dataType="string" />
            </Column>

            <Column caption="Cantidad" dataField="CantidadFabricado" width="70" alignment="Right" dataType="number" />

            <Column caption="Ubicación" alignment="Center">
              <Column caption="Código" dataField="CodigoUbicacionIngreso" width="70" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="UbicacionIngreso" width="200" alignment="Left" dataType="string" />
            </Column>

            <MasterDetail
              enabled={true}
              component={PRO_Fabricacion_Detalle}
            />
          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
